module.exports = __webpack_public_path__ + "img/login-icon.c7ab47b8.png";